import flat from './flat'
import { SHOP_ID } from '@/utils/const'
import { confirmUrl } from './const'

// const baseUrl = 'https://learn.baicizhan.com/api/mall/proxy'

/**
 *
 * @param {confirmApi.ConfirmInform} param
 * @returns
 */
export function fetchData(param) {
  const { shopId = SHOP_ID, ...ot } = param
  return flat(`${confirmUrl}/order_confirm`, {
    method: 'POST',
    body: {
      shopId: shopId,
      ...ot,
    },
  })
}

export function agreePro() {
  ///api/mall/proxy/order/user_agreement
  return flat(`${confirmUrl}/user_agreement`)
}

export function agreePreSell() {
  ///api/mall/proxy/order/presell
  return flat(`${confirmUrl}/presell`)
}

export function checkOrder(orderId) {
  ///api/mall/proxy/order/order_info
  return flat(`${confirmUrl}/order_info?orderId=${orderId}&shopId=${SHOP_ID}`)
}

export function orderSubimt(param) {
  const { shopId = SHOP_ID, ...ot } = param
  return flat(`${confirmUrl}/order_submit`, {
    method: 'POST',
    body: {
      shopId: shopId,
      ...ot,
    },
  })
}

/**
 * 创建订单
 * @param {object} param
 */
export function createOrder(param) {
  ///api/mall/proxy/order/order_create
  const { shopId = SHOP_ID, ...ot } = param

  return flat(`${confirmUrl}/order_create`, {
    method: 'POST',
    body: {
      shopId: shopId,
      ...ot,
    },
  })
}

///api/mall/proxy/order/get_add_on_items
/**
 * 创建订单
 * @param {object} param
 */
export function getPostageCollect(D) {
  ///api/mall/proxy/order/order_create
  return flat(`${confirmUrl}/get_add_on_items?shopId=${SHOP_ID}`)
}
